import { useEffect } from "react";

/**
 * Prevents mouse-wheel from changing focused `<input type="number">` values
 * (browser default). Applies app-wide for all products/screens.
 */
export function useDisableNumberInputWheel(): void {
  useEffect(() => {
    const onWheel = (event: WheelEvent) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) {
        return;
      }
      if (target.type !== "number") {
        return;
      }
      // Stop value change; blur so further wheel scrolls the page instead.
      event.preventDefault();
      target.blur();
    };

    document.addEventListener("wheel", onWheel, { passive: false });
    return () => {
      document.removeEventListener("wheel", onWheel);
    };
  }, []);
}
